import { useLayoutEffect, useRef, useState } from 'react';

import { getFileBlob } from '../data/file-blobs';

const ID_SEPARATOR = '\n';

export function useFileObjectUrls(fileIds: readonly string[]): ReadonlyMap<string, string> {
  const idsKey = fileIds.join(ID_SEPARATOR);
  const createdRef = useRef(new Map<string, string>());
  const [urls, setUrls] = useState<ReadonlyMap<string, string>>(() => new Map());

  useLayoutEffect(() => {
    const created = createdRef.current;
    const ids = new Set(idsKey ? idsKey.split(ID_SEPARATOR) : []);
    created.forEach((url, id) => {
      if (ids.has(id)) return;
      URL.revokeObjectURL(url);
      created.delete(id);
    });
    for (const id of ids) {
      const blob = created.has(id) ? undefined : getFileBlob(id);
      if (blob) created.set(id, URL.createObjectURL(blob));
    }
    setUrls(new Map(created));
  }, [idsKey]);

  useLayoutEffect(() => {
    const created = createdRef.current;
    return () => {
      created.forEach((url) => {
        URL.revokeObjectURL(url);
      });
      created.clear();
    };
  }, []);

  return urls;
}
